"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const silo_1 = require("./silo");
const stockpile_1 = require("./stockpile");
const pit_operation_1 = require("./pit-operation");
const hauler_manager_1 = require("./hauler-manager");
const hopper_control_line_1 = require("./hopper-control-line");
const rfid_tag_1 = require("./rfid-tag");
const configurationReducer = (0, redux_1.combineReducers)({
    siloConfig: silo_1.siloConfigReducer,
    pitOperation: pit_operation_1.pitOperationReducer,
    hopperConfig: hopper_control_line_1.hopperConfigReducer,
    haulerManager: hauler_manager_1.haulerManagerReducer,
    stockpileConfiguration: stockpile_1.stockpileConfigReducer,
    rfidTag: rfid_tag_1.rfidTagConfigReducer,
    rfidTagDumpTruck: rfid_tag_1.rfidTagDumpTruckReducer,
    rfidTagHauler: rfid_tag_1.rfidTagHaulerReducer
});
exports.default = configurationReducer;
